// A modal dialog, rendered into document.body rather than where it is written.
//
// THE BUG THIS EXISTS TO PREVENT
//
// Every one of these dialogs is opened from a control inside the capture form, and each contains
// its own <form> - so written in place, the markup nests one form inside another. HTML does not
// allow that: the inner form is not a form, its submit button belongs to the outer one, and
// pressing "Add" submits the deal instead. The dialog closes, nothing is created, and the page
// navigates. There is no error, which is why it survived being shipped.
//
// A portal puts the dialog at the top of the body, where it is a sibling of the form rather than a
// descendant, and the nesting simply does not arise. That is also where a modal belongs: it is not
// part of the form it was opened from, it is over the top of the page.
//
// The <dialog> element itself is worth keeping for what it brings - focus trapping, Escape, the
// top layer, and an inert backdrop - none of which a div reimplements correctly.
//
// AND THE HALF OF THAT BUG A PORTAL DOES NOT FIX
//
// React propagates events through the React tree, not the DOM tree. A portal moves the markup and
// not the event path, so the dialog's own submit still bubbles to the onSubmit of the form it was
// written inside - which is the capture form. preventDefault does not stop that: the dialog closed,
// the entry was created, and the deal was saved as well, by a click on a button that says "Add".
//
// Stopped here rather than in each dialog because every one of them is opened from a form and every
// one of them would need it. A dialog is over the page, not part of it, and nothing it does belongs
// to the form underneath.

import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export default function Modal({ onClose, children }) {
  const ref = useRef(null);

  useEffect(() => {
    // showModal rather than the open attribute: only the former traps focus and makes the rest of
    // the page inert, which is the difference between a modal and something that looks like one.
    ref.current?.showModal();
  }, []);

  return createPortal(
    <dialog ref={ref} onClose={onClose} onSubmit={(event) => event.stopPropagation()}>
      {children}
    </dialog>,
    document.body,
  );
}
